/* eslint-disable */
import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Alert, AlertDescription, AlertIcon, AlertTitle, Badge, Box, Button, Divider, Flex, FormControl, FormHelperText, FormLabel, HStack, Input, Select, SimpleGrid, Stack, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { productPurchaseType, productType } from '../../types';
import { useAppDispatch, useAppSelector } from '../../hooks';

import { AppDispatch } from '../../store';
import BeltImage from '../../theme/assets/delivery-belt.webp';
import IkhokhaSpeedPointImage from '../../theme/assets/ikhokha-speed-point.jpg';
import { ProductCard } from '../../components';
import { ToastContainer } from 'react-toastify';
import TrolleyImage from '../../theme/assets/delivery-trolley.jpg';
import YocoSpeedPoint from '../../theme/assets/yoco-speed-point.jpg';
import { filterByStatus } from '../../utils';
import { getProductPurchases } from '../../store/actions';

export const ViewProducts = () => {

    const [products] = useState<Array<productType>>([
        {
            name: 'belt',
            price: 350,
            description: 'Delivery belt.',
            image: BeltImage,
            supplier: 'Mat logistics',
            supplier_url: 'http://www.google.com',
            shipping_amount: 60,
        },
        {
            name: 'trolley',
            price: 400,
            description: 'Delivery trolley',
            image: TrolleyImage,
            supplier: 'Given accessories',
            supplier_url: 'http://www.google.com',
            shipping_amount: 60,
        },
        {
            name: 'iKhokha moover',
            price: 999,
            description: 'Payment speed point',
            image: IkhokhaSpeedPointImage,
            supplier: 'iKhokha',
            supplier_url: 'http://www.ikhokha.com',
            shipping_amount: 0,
        },
        {
            name: 'Yoco shaker',
            price: 850,
            description: 'Payment speed point',
            image: YocoSpeedPoint,
            supplier: 'Yoco',
            supplier_url: 'http://www.yoco.com',
            shipping_amount: 65
        }
    ]);

    const { company } = useAppSelector(state => state.companyReducer);

    const { orders } = useAppSelector(state => state.productPurchaseReducer);

    const dispatch: AppDispatch = useAppDispatch();

    console.log(Number(`${products.at(0)?.display_price}00`));

    useEffect(() => {
        dispatch(getProductPurchases());
    }, []);

    return (
        <>
            <Flex
                minH={'-webkit-fill-available'}
                align={'center'}
                justify={'center'}
                flexDirection={'column'}
                py={10}
            >
                <Stack>
                    <HStack justifyContent={'space-between'}>
                        <Text fontSize={'xl'} fontWeight={'medium'}>Market place and MyStore</Text>
                    </HStack>
                    <Text pb={4} color={'gray.500'}>The place to work with our partners. You can stock from us and run your store with our partners and we'll make sure that your clients and customers can buy from your website.</Text>
                    {
                        orders.length &&
                        <Accordion defaultIndex={[0]} allowMultiple bg={'#FFFFFF'} borderRadius={6}>
                            <AccordionItem>
                                <h2>
                                    <AccordionButton _hover={{ bg: '#fff8e1' }}>
                                        <Box flex='1' textAlign='left'>
                                            <Text fontWeight={'medium'}>Orders: Total <Badge>{orders?.length}</Badge></Text>
                                            <HStack mt={2}>
                                                {filterByStatus(orders, 'pending')?.length && <Badge colorScheme='green'>pending {filterByStatus(orders, 'pending')?.length}</Badge>}
                                                {filterByStatus(orders, 'cancelled')?.length && <Badge colorScheme='red'>cancelled {filterByStatus(orders, 'cancelled')?.length}</Badge>}
                                            </HStack>
                                        </Box>
                                        <AccordionIcon />
                                    </AccordionButton>
                                </h2>
                                <AccordionPanel pb={4} bg={'#f5f5f5'}>
                                    {
                                        orders?.length &&
                                        <>
                                            {
                                                orders.map((order: productPurchaseType, index: number) => (
                                                    <HStack key={index} bg={'#FFFFFF'} px={3} py={2} justifyContent={'space-between'} borderRadius={4} shadow={'sm'}>
                                                        <Stack>
                                                            <Text fontWeight={'medium'} fontSize={16}>{order?.name} <Badge colorScheme={order?.status === 'cancelled' ? 'red' : 'green'}>{order?.status}</Badge></Text>
                                                            <Text color={'gray.500'} fontWeight={'light'}>{order?.description}</Text>
                                                            <HStack>
                                                                <Text fontWeight={'light'}>{order?.purchase_id}</Text>
                                                                {/* <Badge colorScheme={order?.payment_status === 'paid' ? 'green' : 'gray'}>{order?.payment_status === 'paid' ? 'Paid' : 'Unpaid'}</Badge> */}
                                                            </HStack>
                                                        </Stack>
                                                        <HStack>
                                                            {/* <Button loadingText={order?.status === 'cancelled' ? 'Deleting' : 'cancelling'} colorScheme='red' size={'sm'}  >{order?.status === 'cancelled' ? 'Delete' : 'Cancel'}</Button> */}
                                                        </HStack>
                                                    </HStack>
                                                ))
                                            }
                                        </>
                                    }
                                </AccordionPanel>
                            </AccordionItem>
                        </Accordion>
                    }
                    <Stack>
                        <Alert status='info' borderRadius={6}>
                            <AlertIcon />
                            <Box>
                                <AlertTitle>Good news!</AlertTitle>
                                <AlertDescription>
                                    You can now have your own store and sell products that your customers and clients need. We've partnered with iKhokha and Yoco to help you setup your store.
                                </AlertDescription>
                            </Box>
                        </Alert>
                        <Tabs colorScheme={'yellow'}>
                            <TabList>
                                <Tab>Market Place</Tab>
                                <Tab>MyStore</Tab>
                            </TabList>

                            <TabPanels>
                                <TabPanel>
                                    <Stack bg={'#FFFFFF'} p={6} borderRadius={6}>
                                        <Stack>
                                            <Text fontSize={24} fontWeight={'bold'} mb={0}>Trucklivery Market Place</Text>
                                            <Text color={'#9e9e9e'} mt={'0px !important'}>Allow us to help you with all the resources you might need to run your business.</Text>
                                            <Text textTransform={'capitalize'} fontSize={16} fontWeight={'medium'} mt={'1rem !important'}>all products</Text>
                                        </Stack>
                                        <Divider />
                                        <Stack mt={6}>
                                            <SimpleGrid columns={[1, 2, 3, 4]} spacing='20px'>
                                                {
                                                    products?.map((product: productType, index: number) => (
                                                        <ProductCard
                                                            key={index}
                                                            email={company?.email}
                                                            {...product}
                                                        />
                                                    ))
                                                }
                                            </SimpleGrid>
                                        </Stack>
                                    </Stack>
                                </TabPanel>
                                <TabPanel>
                                    <Stack bg={'#FFFFFF'} p={6} borderRadius={6}>
                                        <Text fontSize={24} fontWeight={'bold'} mb={0}>MyStore</Text>
                                        <Text color={'#9e9e9e'} mt={'0px !important'}>Setup your online store details.</Text>
                                        <Divider />
                                        <Stack>
                                            <FormControl>
                                                <FormLabel>Store provider</FormLabel>
                                                <Select placeholder='Select provider' maxW={350}>
                                                    <option value='ikhokha'>iKhokha</option>
                                                    <option value='yoco'>Yoco</option>
                                                </Select>
                                                <FormHelperText>The partner that you'll use to setup your store with.</FormHelperText>
                                            </FormControl>
                                            <FormControl>
                                                <FormLabel>Store name</FormLabel>
                                                <Input type='text' placeholder='Enter store name' />
                                                <FormHelperText>The name that will appear on your website store page.</FormHelperText>
                                            </FormControl>
                                            <FormControl>
                                                <FormLabel>Store url/link</FormLabel>
                                                <Input type='text' placeholder='Enter store url/link' />
                                                <FormHelperText>We'll use this link to add yur store on the website.</FormHelperText>
                                            </FormControl>
                                            <br />
                                            <Button colorScheme={'yellow'} maxW={300}>Submit</Button>
                                        </Stack>
                                    </Stack>
                                </TabPanel>
                            </TabPanels>
                        </Tabs>
                    </Stack>
                </Stack>
                <ToastContainer />
            </Flex>
        </>
    );
};